import type { SubscriptionTier } from '@invoice-simple/common';

import axios from 'axios';

import { LegacyUsageGroup } from '@invoice-simple/common';

import UserModel from 'src/models/UserModel';
import { getOptimizelyFlag } from 'src/services/flags/utils/flags';
import EnvironmentStore from 'src/stores/EnvironmentStore';

export interface SubscriptionsResponse {
  upgrades: Record<string, any>[];
  subscriptions: Record<string, any>[];
  docsThresholdCount: number;
  docsCountLastMonth: number;
  accountCreationTimestamp: number | null;
  hadPaidSubsInthePast?: boolean;
}

export interface SubscriptionStatus {
  active: boolean;
  activeUntil: number;
  hasFreeSub: boolean;
  hasPaidSub: boolean;
  isWebAndMobile?: boolean;
  subscriptionTier: SubscriptionTier | null;
  planInterval: string | null;
  hadPaidSubsInThePast: boolean;
  hadFreeTrialSubInThePast: boolean; // only for 14 day free trial
  docsThresholdCount: number;
  allDocsCount?: number;
  docsCountLastMonth?: number;
  accountCreationTimestamp: number;
  orderSku: string;
  legacyUsageGroup?: LegacyUsageGroup | null;
}

type RequestProps = {
  baseURL: string;
  RCEnabled: boolean;
};

export const getSubscriptionStatusV3 = async (user: UserModel) => {
  const { headers } = user.getApiV3ReqOpts();
  const { RCEnabled, baseURL } = await getRequestProperties();
  const path = baseURL + '/subscription-status';

  const { data } = await axios.request<SubscriptionStatus>({
    url: path,
    method: RCEnabled ? 'GET' : 'POST',
    headers
  });

  return data;
};

export const getSubscriptionsV3 = async (user: UserModel) => {
  const { headers } = user.getApiV3ReqOpts();
  const { baseURL } = await getRequestProperties();

  const path = baseURL + '/subscriptions';
  const { data } = await axios.get<Record<string, any>[]>(path, { headers });

  return data;
};

export const cancelSubscription = async (user: UserModel) => {
  const { headers } = user.getApiV3ReqOpts();
  const { RCEnabled, baseURL } = await getRequestProperties();
  const cancelPath = RCEnabled ? '/subscription/cancel' : '/subscription-cancel';
  const path = baseURL + cancelPath;

  await axios.request({
    url: path,
    method: RCEnabled ? 'PUT' : 'POST',
    headers
  });
};

export const getRequestProperties = async (): Promise<RequestProps> => {
  const isRevenueCatEnabled = await getOptimizelyFlag('revenue_cat');

  return {
    baseURL: isRevenueCatEnabled.enabled
      ? `${EnvironmentStore.subscriptionUrl}/api/v1`
      : `${EnvironmentStore.appApiUrl}/api/v3/app`,
    RCEnabled: isRevenueCatEnabled.enabled
  };
};
